<h2 class="text-center">{{ label }}</h2>
@if (error) {
  <div>
    <div class="error">
      <em class="fa fa-book"></em>
      <p class="text-center error-message">{{ error }}</p>
    </div>
  </div>
} @else {
  <div [innerHtml]="novelist | safeHtml"></div>
}
@if (loader) {
  <div>
    <mat-spinner class="spinner" diameter="50"></mat-spinner>
  </div>
}
